<template>
    <div class="container basket mt-2">
        <div class="row">
            <div class="col">

                <template v-for="(item, index) in items">
                    <!-- fav-item -->
                    <div class="basket-item">
                        <div class="basket-item-header">
                            <div class="basket-item-h1">
                                <div class="basket-item-h1-inner">
                                    <template v-if="item.images.length > 0">
                                        <a :href="'/product/' + item.slug" class="basket-item-img" :style="'background-image: url(' + item.images[0] + ');'"></a>
                                    </template>
                                    <template v-else>
                                            <a :href="'/product/' + item.slug" class="basket-item-img" style="background-image: url(/i/nophoto.png);"></a>
                                    </template>
                                    <div class="basket-item-control">
                                        <button v-if="!inCart(item.id)" type="button" class="btn btn-outline-cart btn-bi btn-cart"
                                                @click.prevent="addToCart(item.id)">
                                            <i class="bi bi-basket2"></i><ins>В корзину</ins>
                                        </button>
                                        <button v-else type="button" class="btn btn-bi btn-cart"
                                                @click.prevent="deleteFromCart(item.id)">
                                            <i class="bi bi-basket2"></i><ins>В корзине</ins>
                                        </button>
                                        <button type="button" class="btn btn-outline-regular btn-bi btn-fav"
                                                @click.prevent="deleteFromFavourites(item.id)">
                                            <i class="bi bi-trash"></i><ins>Удалить</ins>
                                        </button>
                                    </div>
                                </div>
                                <div class="basket-item-info">
                                    <div class="articul">Артикул {{ item.sku }}</div>
                                    <div class="link"><a :href="'/product/' + item.slug" class="item-link">{{ item.name }}</a></div>
                                </div>
                            </div>
                            <div class="basket-item-h2">
                                <div class="basket-item-price item-price item-price-h3">
                                    <span v-if="item.price_old" class="price-old">{{ item.price_old }}Р</span>
                                    <span v-if="item.discount" class="price-off">{{ item.discount }}Р</span>
                                    <span class="price-current">{{ item.price }}Р</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- /fav-item -->
                </template>

            </div>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        deleteFromFavourites(id) {
            this.$store.dispatch('favourites/deleteFromFavourites', id);
        },

        inCart(id) {
            return this.$store.state.cart.items.find(x => x.id == id);
        },

        addToCart(id) {
            this.$store.dispatch('cart/addToCart', id)
        },

        deleteFromCart(id) {
            this.$store.dispatch('cart/deleteFromCart', id)
        }
    },

    computed: {
        items() {
            return this.$store.state.favourites.items;
        },
    },
};
</script>
